import { Tag } from 'antd';
import styled, { css } from 'styled-components';

export const PostWrapper = styled.div<{ $isFeatured?: boolean }>`
  position: relative;
  display: flex;
  padding: 12px 8px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid transparent;
  ${({ $isFeatured }) =>
    $isFeatured &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.purple6};
    `}
`;

export const FeaturedTag = styled(Tag)`
  position: absolute;
  top: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.purple6};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  margin-inline-end: 0 !important;
  border-radius: 0px 2px 0px 4px;
`;

export const StyledImage = styled.img`
  width: 67px;
  height: 48px;
  aspect-ratio: 67/48;
  border-radius: 4px;
  flex: none;
  object-fit: cover;
`;

export const InfoWrapper = styled.div`
  display: flex;
  max-height: 108px;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: hidden;
`;

export const BottomWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.black7};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TitleWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;
